module.exports = __webpack_public_path__ + "static/media/bg.cc069994.mp3";